module.exports = __webpack_public_path__ + "img/muscle1.f39b1747.png";